import { useCallback } from "react";
import { useCachedQuery } from "./useCachedQuery";
import { fetchTenantSnapshots, type TenantSnapshots } from "./useAdminStatus";
import { instanceSnapshotsResource } from "../lib/adminQueries";

export type InstanceSnapshotsResult = {
  status: "loading" | "ready" | "error";
  snapshots: TenantSnapshots | null;
  error: string | null;
  isFetching: boolean;
};

// Restore points don't depend on the dashboard time range (DLM keeps a fixed
// retention set), so there's one cache resource and one query regardless of range.
export const useInstanceSnapshots = (tenantId: string): InstanceSnapshotsResult => {
  const fetcher = useCallback(
    (signal: AbortSignal): Promise<TenantSnapshots> => fetchTenantSnapshots(tenantId, signal),
    [tenantId],
  );
  const { status, data, error, isFetching } = useCachedQuery<TenantSnapshots>({
    cacheResource: instanceSnapshotsResource(tenantId),
    queryKey: `/api/admin/claws/${tenantId}/snapshots`,
    fetcher,
  });
  return { status, snapshots: data, error, isFetching };
};
